module.exports = __webpack_public_path__ + "d9cecc6d19898cdf481e49a12c96147b.fbx";